import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import ConferenceChairs from './pages/ConferenceChairs';
import ChairDetail from './pages/ChairDetail';
import StructureAcoustic from './pages/StructureAcoustic';
import ServiceDetail from './pages/ServiceDetail';
import NishPMC from './pages/NishPMC';
import ModularHalls from './pages/ModularHalls';
import NishRenew from './pages/NishRenew';
import TechnicalArticles from './pages/TechnicalArticles';
import ArticleDetail from './pages/ArticleDetail';
import References from './pages/References';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Projects from './pages/Projects';
import Configurator from './pages/Configurator';
import './App.css';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/conference-chairs" element={<ConferenceChairs />} />
          <Route path="/conference-chairs/:id" element={<ChairDetail />} />
          <Route path="/structure-acoustic" element={<StructureAcoustic />} />
          <Route path="/structure-acoustic/:slug" element={<ServiceDetail />} />
          <Route path="/nish-pmc" element={<NishPMC />} />
          <Route path="/modular-halls" element={<ModularHalls />} />
          <Route path="/nish-renew" element={<NishRenew />} />
          <Route path="/technical-articles" element={<TechnicalArticles />} />
          <Route path="/technical-articles/:id" element={<ArticleDetail />} />
          <Route path="/references" element={<References />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/design-your-hall" element={<Configurator />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
